import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center  border-transparent bg-transparent h-[26px] text-[12px] font-medium border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2  bg-opacity-10 px-2 py-1 text-[12px]'
);

export interface TagsProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
  variant?: 'default' | 'prefix' | 'text';
  title?: string;
}

function Tags({ className, variant, icon, title = '', ...props }: TagsProps) {
  switch (variant) {
    case 'text':
      return (
        <div className='border-transparent text-[12px] font-medium rounded-lg flex items-center justify-center'>
          <div
            className={cn('!rounded-tr-lg !rounded-br-lg !pl-[5px]', badgeVariants(), className)}
          >
            {icon}
          </div>
          <div
            className={cn('!rounded-tl-lg !rounded-bl-lg !pr-0', badgeVariants(), className)}
            {...props}
          />
          {title}
        </div>
      );

    case 'prefix':
      return (
        <div className='text-[12px] font-medium leading-[20.73]  h-[29px] flex items-center gap-[1px] '>
          <div
            className={cn(
              'px-2 !rounded-tr-lg !w-[32px] !h-[26px] !rounded-br-lg',
              badgeVariants(),
              className
            )}
          >
            {icon}
          </div>
          <div
            className={cn('!rounded-tl-lg !h-[26px] !rounded-bl-lg', badgeVariants(), className)}
            {...props}
          />
          {title}
        </div>
      );
    default:
      return (
        <div className='border-transparent text-[12px] font-medium leading-[20.73px] rounded-lg h-[29px]  flex items-center  '>
          <div className={cn('rounded-lg', badgeVariants(), className)} {...props} />
          {title} <div></div>
        </div>
      );
  }
}

export { Tags, badgeVariants };
